import { colorAndOpacityToRGBA } from '../../helpers'

function buildCaptionWindowElementProps(captionStyles) {
  let style = {}
  let className = 'caption-window-element'
  if (captionStyles.windowOpacity === 'flashing') {
    className = `${className} ${
      PLATFORM_HAS_FLASHING_CAPTIONS ? 'opacityflash' : 'opacityblink'
    } ${captionStyles.windowColor}`
  } else {
    style = {
      backgroundColor: colorAndOpacityToRGBA(
        captionStyles.windowColor,
        captionStyles.windowOpacity
      ),
    }
  }
  return { style, className }
}

function buildCaptionBackgroundElementProps(captionStyles) {
  let style = {}
  let className = 'caption-background-element'
  if (captionStyles.bgOpacity === 'flashing') {
    className = `${className} ${
      PLATFORM_HAS_FLASHING_CAPTIONS ? 'opacityflash' : 'opacityblink'
    } ${captionStyles.bgColor}`
  } else {
    style = {
      backgroundColor: colorAndOpacityToRGBA(
        captionStyles.bgColor,
        captionStyles.bgOpacity
      ),
    }
  }
  return { style, className }
}

function buildCaptionTextElementProps(captionStyles) {
  let style = {
    color: captionStyles.fgColor,
    fontSize: captionStyles.fontSize,
    fontFamily: captionStyles.fontStyle,
    fontStyle: captionStyles.captionStyle === 'italic' ? 'italic' : 'normal',
    fontWeight: captionStyles.captionStyle === 'bold' ? 'bold' : 'normal',
    textShadow: captionStyles.textShadowValue,
  }
  let className = 'caption-text-element'
  if (captionStyles.fgOpacity === 'flashing') {
    className = `${className} ${
      PLATFORM_HAS_FLASHING_CAPTIONS ? 'opacityflash' : 'opacityblink'
    } opacitytext`
  } else {
    style.opacity = captionStyles.fgOpacity
  }
  return { style, className }
}

function buildStylesAndClasses(captionStyles = {}) {
  const captionWindowElementProps =
    buildCaptionWindowElementProps(captionStyles)
  const captionBackgroundElementProps =
    buildCaptionBackgroundElementProps(captionStyles)
  const captionTextElementProps = buildCaptionTextElementProps(captionStyles)
  return {
    captionWindowElementProps,
    captionBackgroundElementProps,
    captionTextElementProps,
  }
}

export default buildStylesAndClasses
